import React, { FC } from 'react';
import { useClsArchiveIssuesQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface SelectCls extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
}

const ArchiveIssues: FC<SelectCls> = ({ label, error, control, name, rules }) => {
  const { data } = useClsArchiveIssuesQuery();
  return (
    <Select
      label={label}
      data={(data && data.classifierValues) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default ArchiveIssues;
